var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5879 14.7061C16.9777 14.7061 17.2939 14.3898 17.2939 14V2.70605C17.2939 2.31621 16.9777 2 16.5879 2H7.17676C6.78691 2 6.4707 2.31621 6.4707 2.70605V14C6.47072 14.3898 6.78692 14.7061 7.17676 14.7061H16.5879ZM7.41211 2.94141H16.3525V13.7646H7.41211V2.94141ZM11.8828 18C12.2724 17.9998 12.5879 17.6836 12.5879 17.2939V16.1172C12.5876 15.8575 12.3769 15.6475 12.1172 15.6475C11.8577 15.6477 11.6477 15.8577 11.6475 16.1172V17.0586H3.64746V7.17676H5.05859C5.31843 7.17676 5.5292 6.96587 5.5293 6.70605C5.5293 6.44616 5.31849 6.23535 5.05859 6.23535H3.41211C3.02226 6.23535 2.70605 6.55156 2.70605 6.94141V17.2939C2.70605 17.6838 3.02226 18 3.41211 18H11.8828Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.0e7795842de95ed00c40d674968ee5f1.svg";
export { ForwardRef as ReactComponent };